import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { EsignatureWebhookEventView } from "./EsignatureWebhookEventView";
import { EsignatureWebhookEventViewStore } from "../../store/EsignatureWebhookEventViewStore";
import { useStore } from "../../../../hooks";

export const EsignatureWebhookEventViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/esignatureWebhookEvent/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new EsignatureWebhookEventViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <EsignatureWebhookEventView esignatureWebhookEventViewStore={store} />
      </PageLayout>
    </div>
  );
});
